import { useState, useEffect } from "react";

import { useAuthState } from "react-firebase-hooks/auth";
import { auth, db, storage } from "../../../../util/firebase";
import { query, collection, getDocs, where, addDoc } from "firebase/firestore";
import { ref, getDownloadURL, uploadBytesResumable } from "firebase/storage";

import { v4 as uuidv4 } from "uuid";

import { useNavigate } from "react-router-dom";

import BarLoader from "react-spinners/BarLoader";

import { FaChevronLeft } from "react-icons/fa";
import { Button, Input, Modal, ModalBody } from "reactstrap";
import { IoClose } from "react-icons/io5";

function AdminCreateProductPage() {
  const [user] = useAuthState(auth);

  // eslint-disable-next-line
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  // eslint-disable-next-line
  const [userData, setUserData] = useState();
  const fetchUserData = async () => {
    try {
      setIsLoading(true);
      const q = query(collection(db, "users"), where("uid", "==", user?.uid));
      const doc = await getDocs(q);
      const data = doc.docs[0].data();
      setUserData(data);
      setIsLoading(false);
    } catch (err) {
      console.error(err);
      alert("An error occured while fetching user data");
    }
  };
  useEffect(() => {
    if (user) {
      fetchUserData();
    }
    // eslint-disable-next-line
  }, [user]);

  const [name, setName] = useState();
  const [category, setCategory] = useState();
  const [price, setPrice] = useState();
  const [image, setImage] = useState();

  const createProduct = async () => {
    try {
      setIsLoading(true);

      const newProductUid = uuidv4();

      await addDoc(collection(db, "products"), {
        uid: newProductUid,
        name: name,
        category: category,
        price: parseFloat(price),
        image: image
          ? image
          : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fproducts%2Fdefault.png?alt=media&token=9709040f-e9c4-4be3-8e5f-f84ffd64975b",
      });

      if (category === "AVATAR ICONS") {
        await addDoc(collection(db, "avatars"), {
          category: "Sporty",
          image: image
            ? image
            : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fproducts%2Fdefault.png?alt=media&token=9709040f-e9c4-4be3-8e5f-f84ffd64975b",
          isPremium: true,
          productUid: newProductUid,
          beneficiaryUids: [],
        });
      } else if (category === "PROFILE BANNERS") {
        await addDoc(collection(db, "banners"), {
          category: "Premium",
          imageMobile: image
            ? image
            : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fproducts%2Fdefault.png?alt=media&token=9709040f-e9c4-4be3-8e5f-f84ffd64975b",
          isPremium: true,
          productUid: newProductUid,
          beneficiaryUids: [],
        });
      }

      navigate(-1);

      setIsLoading(false);
    } catch (err) {
      alert(err.message);
      setIsLoading(false);
    }
  };

  const [newProductImage, setNewProductImage] = useState();
  const [newProductImagePreview, setNewProductImagePreview] = useState();
  const [changeProductImageModalIsOpen, setChangeProductImageModalIsOpen] =
    useState(false);
  const [isModalLoading, setIsModalLoading] = useState(false);

  const toggleChangeProductImageModal = () => {
    setChangeProductImageModalIsOpen(!changeProductImageModalIsOpen);
  };

  const handleChangeNewProductImage = (e) => {
    setNewProductImage(e.target.files[0]);
    setNewProductImagePreview(URL.createObjectURL(e.target.files[0]));
  };

  const selectNewProductImage = () => {
    document.getElementById("selectImage").click();
  };

  const handleUploadNewProductImage = async () => {
    setIsModalLoading(true);

    const storageRef = ref(
      storage,
      `assets/productsNew/${newProductImage.name}`
    );
    await uploadBytesResumable(storageRef, newProductImage).then((snapshot) => {
      getDownloadURL(snapshot.ref).then((downloadURL) => {
        setImage(downloadURL);
        setIsModalLoading(false);
        toggleChangeProductImageModal();
      });
    });
  };

  if (isLoading)
    return (
      <div className="loadingPage">
        <img
          alt="logo"
          src="https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Flogos%2F01%20-%20SL%20Logo%203.png?alt=media&token=2e5a6320-d2d7-45f8-9bc9-a8f9c7f8caa6"
          style={{
            width: 100,
            marginBottom: "1rem",
          }}
        />
        <BarLoader color="#005EE1" />
      </div>
    );

  return (
    <div id="newsArticlePage" className="page">
      <h1>
        <FaChevronLeft
          onClick={() => navigate(-1)}
          style={{
            color: "#005EE1",
            width: 35,
            height: 35,
            marginTop: -8,
            marginRight: "0.25rem",
            cursor: "pointer",
          }}
        />
        CREATE PRODUCT
      </h1>
      <div>
        <div id="adminNewsArticleImageContainer">
          <img
            alt="newsArticleImage"
            src={
              image
                ? image
                : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
            }
            id="newsArticleImage"
          />
          <div className="adminNewsArticleImageOverlay">
            <Button
              onClick={toggleChangeProductImageModal}
              className="primaryBtn"
            >
              ADD
            </Button>
            <Modal
              id="changeNewsArticleImageModal"
              isOpen={changeProductImageModalIsOpen}
              toggle={toggleChangeProductImageModal}
              size={"lg"}
            >
              <ModalBody>
                <div className="modalHeader" style={{ marginBottom: "1rem" }}>
                  <div></div>
                  <IoClose onClick={toggleChangeProductImageModal} />
                </div>
                <div>
                  <h1>ADD IMAGE</h1>
                  {isModalLoading ? (
                    <div
                      style={{
                        height: 300,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}
                    >
                      <BarLoader color="#005EE1" />
                    </div>
                  ) : (
                    <div style={{ marginTop: "1rem" }}>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          marginBottom: "1rem",
                        }}
                      >
                        <img
                          alt="articleImage"
                          src={
                            newProductImagePreview
                              ? newProductImagePreview
                              : "https://firebasestorage.googleapis.com/v0/b/sport-league-e35d7.appspot.com/o/assets%2Fitems%2FdefaultItem.png?alt=media&token=868921ca-e482-437a-b6f1-d02cb5a877b3"
                          }
                          style={{ height: 250, width: 651.4 }}
                        />
                      </div>
                      <Input
                        id="selectImage"
                        type="file"
                        className="mainInput"
                        accept="image/*"
                        onChange={handleChangeNewProductImage}
                        style={{ display: "none" }}
                      />
                      <Button
                        onClick={selectNewProductImage}
                        className="secondaryBtn"
                        style={{ marginBottom: "0.5rem", color: "#005EE1" }}
                      >
                        {newProductImage?.name
                          ? newProductImage.name
                          : "CHOOSE IMAGE (1024x576px)"}
                      </Button>
                      <Button
                        onClick={handleUploadNewProductImage}
                        disabled={!newProductImage?.name}
                        className="primaryBtn"
                      >
                        ADD
                      </Button>
                    </div>
                  )}
                </div>
              </ModalBody>
            </Modal>
          </div>
        </div>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Name
        </p>
        <input
          type="text"
          className="mainInput"
          value={name}
          onChange={(e) => setName(e.target.value)}
          placeholder="The product's name"
          style={{ marginBottom: "0.5rem" }}
        />
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Category
        </p>
        <Input
          type="select"
          className="mainInput"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          defaultValue={""}
          style={{ marginBottom: "0.5rem" }}
        >
          <option value="" disabled>
            The product's category
          </option>
          <option value="OFFERS">Offer</option>
          <option value="KEYS">Key</option>
          <option value="STAR COINS">Star coin</option>
          <option value="AVATAR ICONS">Avatar icon</option>
          <option value="PROFILE BANNERS">Profile banner</option>
          <option value="TICKET BOOSTS">Ticket boost</option>
          <option value="REWARDS">Reward</option>
        </Input>
        <p className="inputLabel" style={{ textAlign: "left" }}>
          Price
        </p>
        <input
          type="number"
          className="mainInput"
          value={price}
          onChange={(e) => setPrice(e.target.value)}
          placeholder="The product's price"
          style={{ marginBottom: "0.5rem" }}
        />
        <Button
          onClick={createProduct}
          className="primaryBtn"
          style={{ marginTop: "1rem" }}
          disabled={!name || !category || !price}
        >
          CREATE PRODUCT
        </Button>
      </div>
    </div>
  );
}

export default AdminCreateProductPage;
